import { render } from "./bookkeeping.vue?vue&type=template&id=4039e8d7&scoped=true"
import script from "./bookkeeping.vue?vue&type=script&lang=js"
export * from "./bookkeeping.vue?vue&type=script&lang=js"

import "./bookkeeping.vue?vue&type=style&index=0&id=4039e8d7&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4039e8d7"]])

export default __exports__